<script>
import PickKupecInline from '@/components/PickKupecInline';
import settings from '@/settings.js';
import service from '@/service';
import { format, parse } from 'date-fns';

export default {
	components: {
		'pick-kupec-inline': PickKupecInline
	},
	props: {
		prodajalci: Array,
		kupci: Array
	},
	methods: {
		showModal: function (id, prodajaId, prodajalec, kupec, datumProdaje, datumPlaniraneDobave, urejenoFinanciranje, vlozeno, podpisano, financiranjeRci, external, externalKupecHr) {
			this.item_id = id;
			this.prodaja_id = null;
			if (prodajaId) {
				this.prodaja_id = prodajaId;
			}
			this.clearModalData();
			// prodajalec
			this.prodajalci_selected = null;
			if (prodajalec) {
				// select existing user
				for (let item of this.vsiProdajalci) {
					if (prodajalec === item.id) {
						this.prodajalci_selected = item;
						break;
					}
				}
			} else {
				// select current user
				for (let item of this.vsiProdajalci) {
					if (this.user.email === item.email) {
						this.prodajalci_selected = item;
						break;
					}
				}
			}
			// kupec
			if (kupec) {
				this.$nextTick(() => {
					this.$refs.pickKupec.select(kupec);
				});
			} else {
				this.$nextTick(() => {
					this.$refs.pickKupec.select(null);
				});
			}
			// datum prodaje
			if (datumProdaje) {
				let dp = parse(datumProdaje, settings.dbDtFormat);
				this.datum_prodaje = format(dp, settings.inputDtFormat);
			}
			// datum planirane izdaje
			if (datumPlaniraneDobave) {
				let dpi = parse(datumPlaniraneDobave, settings.dbDtFormat);
				this.datum_planirane_izdaje = format(dpi, settings.inputDtFormat);
			}
			// dodatni podatki
			if (urejenoFinanciranje != null) {
				this.urejeno_financiranje = (urejenoFinanciranje === 1);
			}
			if (vlozeno != null) {
				this.vlozeno = (vlozeno === 1);
			}
			if (podpisano != null) {
				this.podpisano = (podpisano === 1);
			}
			if (financiranjeRci != null) {
				this.financiranje_rci = (financiranjeRci === 1);
			}
			this.external = external;
			this.externalKupecHr = externalKupecHr;
			// enable editing for super admins if sell not external
			this.prodajalci_disabled = true;
			if (this.user.role === 5 && !this.external) {
				this.prodajalci_disabled = false;
			}
			this.$refs.modal.show();
		},
		onOkModal: function (evt) {
			evt.preventDefault();
			if (!this.item_id) {
				this.showError('Vozilo ni izbrano');
				return;
			}
			if (!this.prodajalci_selected) {
				this.showError('Prodajalec ni izbran');
				return;
			}
			if (!this.external && !this.kupec_selected) {
				this.showError('Kupec ni izbran');
				return;
			}
			if (!this.datum_prodaje) {
				this.showError('Datum prodaje ni izbran');
				return;
			}
			if (!this.datum_planirane_izdaje) {
				this.showError('Kupec planirane izdaje ni izbran');
				return;
			}
			if (this.urejeno_financiranje == null) {
				this.showError('Stanje urejenega financiranja ni izbrano');
				return;
			}
			if (this.vlozeno == null) {
				this.showError('Stanje vloženosti ni izbrano');
				return;
			}
			if (this.podpisano == null) {
				this.showError('Stanje podpisa ni izbrano');
				return;
			}
			if (this.financiranje_rci == null) {
				this.showError('Stanje RCI financiranja ni izbrano');
				return;
			}
			// submit prodaja
			this.showError(null);
			this.in_progress = true;
			service.prodajVozilo(this.item_id, this.prodaja_id, this.prodajalci_selected, this.kupec_selected, this.datum_prodaje, this.datum_planirane_izdaje, this.urejeno_financiranje, this.vlozeno, this.podpisano, this.financiranje_rci, this.external)
				.then(response => {
					this.$refs.modal.hide();
					this.clearModalData();
					this.$emit('sell-success');
				})
				.catch(error => {
					this.in_progress = false;
					this.processAddError(error);
					if (error) {
						console.log(error);
					}
				});
		},
		processAddError: function (error) {
			if (!error) {
				this.showError('Napaka pri prodaji (G)');
				return;
			}
			console.log(error);
			if (!error.response || !error.response.status || error.response.status !== 400) {
				this.showError('Prodaja ni uspela (S)');
				return;
			}
			if (!error.response.data || !error.response.data.code || !error.response.data.message) {
				this.showError('Prodaja ni uspela (U)');
				return;
			}
			this.showError(`${error.response.data.message} (#${error.response.data.code})`);
		},
		clearModalData: function () {
			this.kupec_selected = null;
			this.datum_prodaje = '';
			this.datum_planirane_izdaje = '';
			this.urejeno_financiranje = null;
			this.vlozeno = null;
			this.podpisano = null;
			this.financiranje_rci = null;
			this.external = false;
			this.externalKupecHr = '';
			this.action_message_type = null;
			this.action_message = null;
			this.in_progress = false;
		},
		loadProdajalci: function () {
			this.prodajalci_options = [];
			service.getProdajalci()
				.then(prodajalci => {
					for (let item of prodajalci) {
						item.full_name = item.first_name + ' ' + item.last_name;
					}
					this.prodajalci_options = prodajalci;
				})
				.catch(error => {
					if (error) {
						console.log(error);
					}
				});
		},
		showError: function (message) {
			this.action_message_type = this.ACTION_TYPE_ERROR;
			this.action_message = message;
		}
	},
	data: function () {
		return {
			item_id: null,
			prodaja_id: null,
			prodajalci_disabled: true,
			prodajalci_selected: null,
			prodajalci_options: null,
			kupec_selected: null,
			datum_prodaje: '',
			datum_planirane_izdaje: '',
			urejeno_financiranje: null,
			vlozeno: null,
			podpisano: null,
			financiranje_rci: null,
			external: false,
			externalKupecHr: '',
			action_message_type: null,
			action_message: null,
			in_progress: false,
			ACTION_TYPE_ERROR: 'ERROR'
		}
	},
	computed: {
		user () {
			return this.$store.getters.user;
		},
		vsiProdajalci () {
			if (this.prodajalci != null) {
				this.prodajalci_options = this.prodajalci;
			} else {
				if (this.prodajalci_options == null) {
					this.loadProdajalci();
				}
			}
			return this.prodajalci_options;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" title="Prodaj vozilo" class="modal-primary" :busy="in_progress" ok-title="Potrdi" cancel-title="Prekliči" @ok="onOkModal">
		<b-form ref="form">
			<b-row>
				<b-col>
					<b-form-group>
						<label>Prodajalec</label>
						<v-select ref="prodajalci"
							v-model="prodajalci_selected"
							:options="vsiProdajalci"
							:disabled="prodajalci_disabled"
							label="full_name"
							placeholder="Izberi prodajalca ...">
						</v-select>
					</b-form-group>
				</b-col>
			</b-row>
			<pick-kupec-inline v-show="!external" ref="pickKupec" v-model="kupec_selected" :kupci="kupci" title="Kupec" />
			<b-row v-show="external">
				<b-col>
					<b-form-group label="Kupec:">
						<b-form-input type="text" v-model="externalKupecHr" disabled></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Datum prodaje*:" label-for="datum_prodaje">
						<b-form-input ref="datum_prodaje" id="datum_prodaje"
							type="date"
							v-model="datum_prodaje"
							required
							placeholder="Datum prodaje"></b-form-input>
					</b-form-group>
				</b-col>
				<b-col>
					<b-form-group label="Datum planirane izdaje*:" label-for="datum_planirane_izdaje">
						<b-form-input ref="datum_planirane_izdaje" id="datum_planirane_izdaje"
							type="date"
							v-model="datum_planirane_izdaje"
							required
							placeholder="Datum planirane izdaje"></b-form-input>
					</b-form-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Urejeno financiranje*:"></b-form-group>
				</b-col>
				<b-col>
					<b-form-radio-group v-model="urejeno_financiranje">
						<b-form-radio value="true">Da</b-form-radio>
						<b-form-radio value="false">Ne</b-form-radio>
					</b-form-radio-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Vloženo*:"></b-form-group>
				</b-col>
				<b-col>
					<b-form-radio-group v-model="vlozeno">
						<b-form-radio value="true">Da</b-form-radio>
						<b-form-radio value="false">Ne</b-form-radio>
					</b-form-radio-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Podpisano*:"></b-form-group>
				</b-col>
				<b-col>
					<b-form-radio-group v-model="podpisano">
						<b-form-radio value="true">Da</b-form-radio>
						<b-form-radio value="false">Ne</b-form-radio>
					</b-form-radio-group>
				</b-col>
			</b-row>
			<b-row>
				<b-col>
					<b-form-group label="Financiranje RCI*:"></b-form-group>
				</b-col>
				<b-col>
					<b-form-radio-group v-model="financiranje_rci">
						<b-form-radio value="true">Da</b-form-radio>
						<b-form-radio value="false">Ne</b-form-radio>
					</b-form-radio-group>
				</b-col>
			</b-row>
			<b-alert :variant="action_message_type && action_message_type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="action_message && action_message !== ''">{{ action_message }}</b-alert>
		</b-form>
	</b-modal>
</template>
<style>
.dropdown-toggle::after {
	border: none;
}
</style>


// WEBPACK FOOTER //
// src/components/ProdajVoziloModal.vue